export default function SwiperVideoNavigation(swiperInstance) {
	let imageTimeout = null;
	const autoplayDelay = 7000;

	let currentVideo = null;

	function handleAutoplay() {
		const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
		const video = activeSlide?.querySelector("video");

		if (currentVideo && currentVideo !== video) {
			currentVideo.removeEventListener("ended", videoEnded);
		}

		if (video) {
			swiperInstance.autoplay.stop();
			currentVideo = video;
			setupVideoEndListener(video);
			video.currentTime = 0;
			video.play();
		} else {
			swiperInstance.autoplay.start();
			handleImageSlide();
		}
	}

	function handleImageSlide() {
		clearTimeout(imageTimeout);
		imageTimeout = setTimeout(() => {
			if (swiperInstance.isEnd) {
				swiperInstance.slideTo(0);
			} else {
				swiperInstance.slideNext();
			}
		}, autoplayDelay);
	}

	function setupVideoEndListener(video) {
		video.addEventListener("ended", videoEnded);
	}

	function videoEnded() {
		if (swiperInstance.isEnd) {
			swiperInstance.slideTo(0);
		} else {
			swiperInstance.slideNext();
		}
	}

	swiperInstance.on("slideChange", () => {
		if (
			!swiperInstance.slides[swiperInstance.activeIndex].querySelector("video")
		) {
			clearTimeout(imageTimeout);
		}
		handleAutoplay();
	});

	handleAutoplay();
}
